__webpack_require__.p = "/tabs-small-screen/onboarding/";